import { createSlice } from '@reduxjs/toolkit';
import {
  EditUserAddress,
  EditUserDetails,
  EditUserPassword,
  EditUserProfile,
  UserGetProfile,
} from './user_profile_service_syn';

export const userProfileSlice = createSlice({
  name: 'user_profile',
  initialState: {
    profile: {},
    profileLoader: true,
    editLoader: false,
    profileMessage: '',
    //edit profile
  },
  reducers: {
    clearState: (state) => {
      state.profile = {};
      state.profileLoader = true;
      state.editLoader = false;
      state.profileMessage = '';

      return state;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserGetProfile.pending, (state) => {
        state.profileLoader = true;
      })
      .addCase(UserGetProfile.fulfilled, (state, { payload }) => {
        state.profileLoader = false;
        state.profileMessage = payload?.message;
        state.profile = payload?.data;
      })
      .addCase(UserGetProfile.rejected, (state, { payload }) => {
        state.profileLoader = false;
        state.profileMessage = payload?.message;
      })
      .addCase(EditUserProfile.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditUserProfile.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
        state.profile = payload.data;
      })
      .addCase(EditUserProfile.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      })

      .addCase(EditUserDetails.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditUserDetails.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
        state.profile = payload.data;
      })
      .addCase(EditUserDetails.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      })

      .addCase(EditUserAddress.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditUserAddress.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
        state.profile = payload.data;
      })
      .addCase(EditUserAddress.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      })
      .addCase(EditUserPassword.pending, (state) => {
        state.editLoader = true;
      })
      .addCase(EditUserPassword.fulfilled, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;

        const addButton = document.querySelector('[data-bs-dismiss="modal"]');

        if (addButton) {
          addButton.click();
        }
      })
      .addCase(EditUserPassword.rejected, (state, { payload }) => {
        state.editLoader = false;
        state.profileMessage = payload.message;
      });
  },
});

export const { clearState } = userProfileSlice.actions;
export const profileSelector = (state) => state.user_profile;

export default userProfileSlice.reducer;
